<!-- Copyright © 2024 Insurance Services Office, Inc. All rights reserved -->

<div *ngIf="this.loader?.loading" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div>